import axios from 'axios';
import { WorkPhaseReportForm } from '../models/investors';

const loadAbort = () => new AbortController();

export const getWorkPhaseReportsEndpoint = (
  projectId: string,
  workPhaseId: string,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'GET',
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/work-phases/${workPhaseId}/reports`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const createWorkPhaseReportEndpoint = (
  projectId: string,
  workPhaseId: string,
  payload: WorkPhaseReportForm,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'POST',
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/work-phases/${workPhaseId}/reports`,
        data: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const updateWorkPhaseReportVisibilityEndpoint = (
  projectId: string,
  workPhaseId: string,
  reportId: string,
  isVisible: boolean,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'PATCH',
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/work-phases/${workPhaseId}/reports/${reportId}/visibility`,
        data: JSON.stringify({ is_visible: isVisible }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const uploadWorkPhaseReportMediaEndpoint = (
  projectId: string,
  workPhaseId: string,
  reportId: string,
  formData: FormData,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'PUT',
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/work-phases/${workPhaseId}/reports/${reportId}/media`,
        data: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const deleteWorkPhaseReportMediaEndpoint = (
  projectId: string,
  workPhaseId: string,
  reportId: string,
  path: string,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'DELETE',
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/work-phases/${workPhaseId}/reports/${reportId}/media`,
        data: JSON.stringify({ path }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};
